import { LuChevronDown, LuEye } from 'react-icons/lu'
import {
	Box,
	HStack,
	Text,
	Table,
	Thead,
	Tbody,
	Image,
	Tfoot,
	Tr,
	Th,
	Td,
	TableCaption,
	TableContainer,
	Button,
	useDisclosure,
	Spinner,
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	MenuDivider,
	Flex,
	Icon,
	AlertDialog,
	AlertDialogOverlay,
	AlertDialogContent,
	AlertDialogHeader,
	AlertDialogBody,
	AlertDialogFooter,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalCloseButton,
	ModalBody,
	ModalFooter
} from '@chakra-ui/react'
import React, { useRef, useState } from 'react'

const TableList = ({ list, getPage }) => {
	const [confirmIndex, setConfirmIndex] = useState(null);
	const [viewToken, setViewToken] = useState(null);
	const cancelRef = useRef();

	const maskToken = (token, visibleStart = 12, visibleEnd = 6) => {
		if (token.length <= visibleStart + visibleEnd) return '***';
		const start = token.slice(0, visibleStart);
		const end = token.slice(-visibleEnd);
		return `${start}********************${end}`;
	};

	const handleConfirmView = (token) => {
		setViewToken(token);
		setConfirmIndex(null);
	};

	const handleCloseModal = () => {
		setViewToken(null);
	};

	return (
		<TableContainer width="100%">
			<Table variant='simple' width="100%" borderWidth="1px" borderColor="#CCCCCC" borderStyle="solid">
				<Thead>
					<Tr>
						<Th>Account Name</Th>
						<Th>Business Number</Th>
						<Th>Token</Th>
						<Th>Status</Th>
						<Th></Th>
					</Tr>
				</Thead>

				<Tbody fontSize="14px">
					{list.map((rs, index) => {
						const configData = JSON.parse(rs.api_config);
						const token = configData.token;

						return (
							<Tr key={index}>
								<Td>{rs.account_name}</Td>
								<Td>{configData.business_name}</Td>
								<Td
									sx={{
										whiteSpace: 'normal',
										wordBreak: 'break-word',
										minWidth: '400px',
										maxWidth: '40%',
										p: 4,
										verticalAlign: 'top',
									}}
								>
									<Flex align="center">
										<Text wordBreak="break-word">
											{maskToken(token)}
										</Text>
										<Icon
											as={LuEye}
											cursor="pointer"
											onClick={() => setConfirmIndex(index)}
											fontSize="lg"
											ml={2}
										/>

									</Flex>

									{/* Confirmation Dialog */}
									<AlertDialog
										isOpen={confirmIndex === index}
										leastDestructiveRef={cancelRef}
										onClose={() => setConfirmIndex(null)}
									>
										<AlertDialogOverlay>
											<AlertDialogContent>
												<AlertDialogHeader fontSize="lg" fontWeight="bold">
													View Token
												</AlertDialogHeader>
												<AlertDialogBody>
													Are you sure you want to view this token? This may expose sensitive information.
												</AlertDialogBody>
												<AlertDialogFooter>
													<Button ref={cancelRef} onClick={() => setConfirmIndex(null)}>
														Cancel
													</Button>
													<Button colorScheme="blue" onClick={() => handleConfirmView(token)} ml={3}>
														View
													</Button>
												</AlertDialogFooter>
											</AlertDialogContent>
										</AlertDialogOverlay>
									</AlertDialog>
								</Td>

								<Td>{rs.status_id === 1 ? "Active" : "InActive"}</Td>

								<Td style={{ color: "#0000EE" }}>
									<Menu>
										<MenuButton fontSize="14px">
											Action
											<Icon as={LuChevronDown} />
										</MenuButton>
										<MenuList style={{ minWidth: "20px", border: "1px solid #CCCCCC" }}>
											<MenuItem h="16px" fontSize="12px" onClick={() => getPage('editWhatsapp', '2', rs)}>
												Edit
											</MenuItem>
										</MenuList>
									</Menu>
								</Td>
							</Tr>
						)
					})}
				</Tbody>
			</Table>

			{/* Token View Modal */}
			<Modal isOpen={viewToken !== null} onClose={handleCloseModal} size="lg">
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>Token</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Box bg="gray.100" p={4} rounded="md" fontFamily="monospace">
							{viewToken}
						</Box>
					</ModalBody>
					<ModalFooter>
						<Button onClick={handleCloseModal}>Close</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</TableContainer>
	)
}

export default TableList;
